// export const legends = [
//   {
//     name: "Weekends",
//     color: "neutrals-100",
//   },
//   {
//     name: "Draft",
//     color: "draft-100",
//   },
//   {
//     name: "Submitted",
//     color: "info-100",
//   },
//   {
//     name: "Approved",
//     color: "success-100",
//   },
//   {
//     name: "Rejected",
//     color: "danger-100",
//   },
//   {
//     name: "Job Inactive",
//     color: "gray-500",
//   },
//   {
//     name: "Leave",
//     color: "leave-100",
//   },
//   {
//     name: "Discrepant",
//     color: "primary-100",
//   },
//   {
//     name: "Invoiced",
//     color: "invoiced-100",
//   },
// ];

export const legends = [
  {
    name: "Weekends",
    color: "bg-neutrals-100",
  },
  {
    name: "Draft",
    color: "bg-draft-100",
  },
  {
    name: "Submitted",
    color: "bg-info-100",
  },
  {
    name: "Approved",
    color: "bg-success-100",
  },
  {
    name: "Rejected",
    color: "bg-danger-100",
  },
  {
    name: "Job Inactive",
    color: "bg-gray-500",
  },
  {
    name: "Leave",
    color: "bg-leave-100",
  },
  {
    name: "Discrepant",
    color: "bg-primary-100",
  },
  {
    name: "Invoiced",
    color: "bg-invoiced-100",
  },
];
